import { AppStatusBarContextProps } from '@psl/appComponents/statusBar/types';
import { createContext } from 'react';

export const AppStatusBarContext = createContext<AppStatusBarContextProps>(
  null as any,
);
